import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import EcoSystemBG01 from '../../../../assets/bg/mobile/bg_ecosystem_01.png'
import EcoSystemBG02 from '../../../../assets/bg/mobile/bg_ecosystem_02.png'
import EcoSystemBG03 from '../../../../assets/bg/mobile/bg_ecosystem_03.png'
import EcoSystemBG04 from '../../../../assets/bg/mobile/bg_ecosystem_04.png'
import EcoSystemBG05 from '../../../../assets/bg/mobile/bg_ecosystem_05.png'

import EcoSystemBG02Content01 from '../../../../assets/bg/mobile/bg_ecosystem_02_content_01.png'
import EcoSystemBG02Content02 from '../../../../assets/bg/mobile/bg_ecosystem_02_content_02.png'
import EcoSystemBG02Icon01 from '../../../../assets/bg/mobile/bg_ecosystem_02_icon_01.png'
import EcoSystemBG02Icon02 from '../../../../assets/bg/mobile/bg_ecosystem_02_icon_02.png'
import EcoSystemBG02Icon03 from '../../../../assets/bg/mobile/bg_ecosystem_02_icon_03.png'
import EcoSystemBG02Icon04 from '../../../../assets/bg/mobile/bg_ecosystem_02_icon_04.png'

import Float from '../../../../styles/float/Float'
import Outer from '../../../../styles/outer/Outer'
import CardItemComponent from './components/CardItem'
import styled from 'styled-components'

const EcosystemMobileComponent = () => {
  const contentMap = [
    {
      id: 0,
      title: 'Content Aspect',
      platform: 'NVIA Platform',
      icon: EcoSystemBG02Icon01,
      content:
        'The NVIA platform supports NFT content transactions through NFT content integrated search services, its own markets, and external markets linked to platforms, and provides curation functions that provide popular content and trend information. Users in the platform ecosystem can easily and easily select and purchase NFT content just as they do when purchasing general products in the online market.',
    },
    {
      id: 1,
      title: 'Credibility Aspect',
      platform: 'NVIA Platform',
      icon: EcoSystemBG02Icon02,
      content:
        'The NVIA platform uses its own blockchain Mainnet MCN to verify the original author of NFT content, evaluate popular NFT content, provide reviews and recommendation indexes by collectors, and secure reliability by providing a user-centered community.',
    },
    {
      id: 2,
      title: 'NVIA Market',
      platform: 'NVIA Platform',
      icon: EcoSystemBG02Icon03,
      content:
        'In the NFT marketplace, users can purchase NFT or sell their own content by minting it, and the purchased NFT content can be resold through the NFT marketplace. In principle, NVIA MARKET operates as a P2P transaction between creators (sellers) and collectors (buyers).',
    },
    {
      id: 3,
      title: 'NVIA Community',
      platform: 'NVIA Platform',
      icon: EcoSystemBG02Icon04,
      content:
        'The NVIA platform will provide communities by category to revitalize NFT category communities such as art and games, filter market disturbance contents through continuous monitoring, grant access to premium NFT specialists through a reward system according to the community activity index, and provide points that can be exchanged with platform tokens.',
    },
  ]
  return (
    <Wrap>
      <img src={EcoSystemBG01} />
      <Outer>
        <img src={EcoSystemBG02} />
        <Float left={37} top={'5%'} w={'83%'}>
          <img src={EcoSystemBG02Content01} />
        </Float>
        <Float top={'29%'}>
          <img src={EcoSystemBG02Content02} />
        </Float>
        <Float top={'61%'}>
          <Swiper modules={[Pagination]} pagination={{ clickable: true }} className='banner' spaceBetween={50} slidesPerView={1} navigation autoplay={{ delay: 1000 }}>
            {contentMap.map((item, idx) => (
              <SwiperSlide key={idx}>
                <CardItemComponent {...item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Float>
      </Outer>
      <img style={{ marginTop: 77 }} src={EcoSystemBG03} />
      <img style={{ marginTop: 99, paddingLeft: 29 }} src={EcoSystemBG04} />
      <img style={{ marginTop: 99, paddingLeft: 29 }} src={EcoSystemBG05} />
    </Wrap>
  )
}

export default EcosystemMobileComponent

const Wrap = styled.div`
  .swiper-pagination {
    bottom: 0px !important;

    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: #4239de !important;
    }
  }
`
